export default __webpack_public_path__ + "b9c2db6654fc51e0c00fdf80238ac301.png";